import { render, staticRenderFns } from "./TableMenu.vue?vue&type=template&id=063dfca2&scoped=true"
import script from "./TableMenu.vue?vue&type=script&lang=js"
export * from "./TableMenu.vue?vue&type=script&lang=js"
import style0 from "./TableMenu.vue?vue&type=style&index=0&id=063dfca2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dfca2",
  null
  
)

export default component.exports